// extracted by mini-css-extract-plugin
module.exports = {"sort":"LU-z","sortSelect":"MU-z","disabled":"NU-z","sortDropdown":"OU-z","visible":"PU-z","personalizedBtn":"QU-z","bfu":"RU-z","selected":"SU-z"};